import ThinkSeedSmallCard from './container';

export default ThinkSeedSmallCard;



// WEBPACK FOOTER //
// ./src/components/Cards/ThinkSeedSmallCard/index.js